import React, { useState, useEffect } from 'react';
import styles from './Contact.module.css';
import emailjs from '@emailjs/browser';

export default function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    emailjs.send(
      'service_nbvdc99',
      'template_60s86z9',
      formData,
      'ch2GDq72CjC4NIZbJ'
    )
    .then(() => {
      setSubmitted(true);
      setIsLoading(false);
      setFormData({ name: '', email: '', message: '' });
    })
    .catch((error) => {
      console.error('EmailJS error:', error);
      alert('Failed to send message. Please try again.');
      setIsLoading(false);
    });
  };

  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => setSubmitted(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [submitted]);

  return (
    <section className={styles.contactSection} id="contact">
      <h2 className={styles.heading}>Get In Touch</h2>
      <p className={styles.subheading}>
        I’m open to work opportunities, freelance, or just a friendly hello! Drop me a message below or email me directly.
      </p>

      <form onSubmit={handleSubmit} className={styles.contactForm}>
        <label htmlFor="name">Name</label>
        <input
          id="name"
          name="name"
          type="text"
          value={formData.name}
          onChange={handleChange}
          required
          maxLength={100}
          placeholder="Your Name"
          aria-label="Your name"
        />

        <label htmlFor="email">Email</label>
        <input
          id="email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
          maxLength={100}
          placeholder="your.email@example.com"
          aria-label="Your email"
        />

        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          rows="5"
          maxLength={1000}
          placeholder="Write your message here..."
          aria-label="Your message"
        />

        <button
          type="submit"
          className={styles.submitBtn}
          disabled={isLoading}
          aria-busy={isLoading}
        >
          {isLoading ? 'Sending...' : 'Send Message'}
        </button>

        {submitted && <p className={styles.thankYou}>Thank you for reaching out! I’ll get back to you soon.</p>}
      </form>

      <div className={styles.directContact}>
        <p><strong>Email:</strong> <a href="mailto:tsionregassa042@gmail.com">tsionregassa042@gmail.com</a></p>
        <p>
          <strong>Socials:</strong>
          <a href="https://linkedin.com/in/tsion-tesfaye-regassa-334205316" target="_blank" rel="noopener noreferrer"> LinkedIn</a> |
          <a href="https://github.com/TsionTesfaye811" target="_blank" rel="noopener noreferrer"> GitHub</a>
        </p>
      </div>

      <div className={styles.resumeDownload}>
        <a href="/resume.pdf" download className={styles.downloadBtn}>
          Download My Resume
        </a>
      </div>
    </section>
  );
}
